'use client';

import { ReactNode, useState } from 'react';

import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';
import cx from 'clsx';

import ChevronDown from '@/components/SvgIcons/ChevronDown';
import Switch from '@/components/Switch';
import colors from '@/styles/themes/colors';

import styles from './CookieAccordion.module.scss';

interface CookieAccordionProps {
  title: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  disabled: boolean;
  children: ReactNode;
}

const CookieAccordion = ({ title, checked, onChange, disabled, children }: CookieAccordionProps) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(prev => !prev);
  };

  const handleSwitchClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <Accordion
      classes={{ root: styles.root }}
      className={cx(styles.container, { [styles.expanded]: expanded })}
      expanded={expanded}
      onChange={handleToggle}
      component="div"
    >
      <AccordionSummary className={styles.summary}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
          <Stack direction="row" alignItems="center" gap={1.5}>
            <Box className={cx(styles.arrowWrapper, { [styles.arrowExpanded]: expanded })}>
              <ChevronDown size={24} props={{ className: styles.arrow }} />
            </Box>
            <Typography component="p" variant="subtitle3" fontWeight={500} color={colors.white}>
              {title}
            </Typography>
          </Stack>
          <Stack width="fit-content" onClick={handleSwitchClick}>
            <Switch checked={checked} onChange={onChange} disabled={disabled} onClick={handleSwitchClick} />
          </Stack>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default CookieAccordion;
